module.exports = __webpack_public_path__ + "img/Puck.08cfe6ad.png";